import React from 'react';
import {Modal, Row, Button}from 'react-bootstrap';

function AlertBox(props) {

    const handleOk = () => {
        props.setShowAlert(false);
    };
  
    const handleCancel = () => {
        props.setShowAlert(false);
    };
    const handleCloseAlertDialog = () => {
        if(props.showAlert)
        {
            props.setShowAlert(false);
        }
    }
    return(
        <>
           <Modal show={props.showAlert ? 1:0} centered onHide={handleCloseAlertDialog} backdrop="static" animation={true} keyboard={true} size="lg" 
            aria-labelledby="contained-modal-title-vcenter" >
                <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='activate_dialog_title_color'>
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body className="grid-example">
                   
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row className='px-3'>
                            {props.body}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleOk}>
                            OK
                        </Button>
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Modal.Footer>
            </Modal> 
           </>
        
    );
}
export default AlertBox;